const namespace = {
  title: "Neighborhood trends",
  noData: "Market trends are not available for this neighborhood at this time.",
  increase: "increase",
  decrease: "decrease",
  disclaimer: "Change over the last twelve months",
  medianSalePrice: "Median sale price over the last twelve months",
  medianSalePriceDisclaimer:
    "Change in median sale price over the last twelve months compared to the previous twelve months",
  medianPriceSQFT: "Median price per square foot over the last twelve months",
  medianPriceSQFTDisclaimer:
    "Change in median price per square foot over the last twelve months compared to the previous twelve months",
  sqftUnit: "/sqft",
  homesSold: "Homes sold over the last twelve months",
  homesSoldDisclaimer:
    "Change in the number of homes sold over the last twelve months compared to the previous twelve months",
  medianYear: "Median construction year of homes",
  medianYearDisclaimer: "sold over the last twelve months",
  dataDisclaimer:
    "Neighborhood trend information is for the selected neighborhood only and is solely based on home transaction data for the trailing 12 months.",
} as const;

export default namespace;
